var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlcohol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Wine-Glass-Bottle--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wine Glass Bottle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.75H10a0.25 0.25 0 0 0 0.25 -0.25v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1v1a0.25 0.25 0 0 0 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 20.37a0.31 0.31 0 0 0 0.21 -0.26v-0.42a0.49 0.49 0 0 0 -0.17 -0.36 5.15 5.15 0 0 1 -1.83 -3.94V13a2.48 2.48 0 0 1 1.7 -2.36 0.39 0.39 0 0 0 0.07 -0.42l-2 -2.44a1 1 0 0 1 -0.23 -0.64V4.5a0.25 0.25 0 0 0 -0.29 -0.25H7.5a0.25 0.25 0 0 0 -0.25 0.25v2.64a1 1 0 0 1 -0.25 0.64l-2 2.44a1 1 0 0 0 -0.23 0.64V22.5a1 1 0 0 0 1 1h5.06a0.29 0.29 0 0 0 0.29 -0.35 2.32 2.32 0 0 1 -0.1 -0.65 2.26 2.26 0 0 1 1.52 -2.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.92 18.79a3.61 3.61 0 0 0 2.33 -3.29V13a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v2.39a3.59 3.59 0 0 0 2.33 3.4 0.24 0.24 0 0 1 0.17 0.23v2.23a0.25 0.25 0 0 1 -0.25 0.25h-1.25a1 1 0 0 0 0 2h5a1 1 0 0 0 0 -2H17a0.25 0.25 0 0 1 -0.25 -0.25V19a0.24 0.24 0 0 1 0.17 -0.21Zm-0.67 -1.29a0.5 0.5 0 0 1 0 -1 1 1 0 0 0 1 -1 0.5 0.5 0 0 1 1 0 2 2 0 0 1 -2 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlcohol);
export default ForwardRef;